import { styled } from '@mui/material/styles'
import { COLORS } from 'styles/colors'
import { GAP_SIZE } from '../constants'

export const RowWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	margin-bottom: ${GAP_SIZE}px;
	width: 100%;
	overflow: visible;
`

export const RowGrid = styled('div')<{
	customCellSize?: number
	hasFullWidget?: boolean
}>`
	display: grid;
	gap: ${GAP_SIZE}px;
	width: ${props => (props.hasFullWidget ? '100%' : 'fit-content')};
	max-width: 100%;
	box-sizing: border-box;
	overflow: visible;

	/* Фиксированные размеры колонок без растягивания */
	grid-template-columns: repeat(
		auto-fit,
		${props => props.customCellSize || 168}px
	);
	grid-auto-rows: ${props => props.customCellSize || 168}px;
`

export const RowInsertZone = styled('div')<{
	isOver?: boolean
	isVisible?: boolean
	isDraggingActive?: boolean
}>`
	min-height: ${props =>
		props.isVisible ? '48px' : props.isDraggingActive ? '36px' : '16px'};
	height: ${props =>
		props.isVisible ? '48px' : props.isDraggingActive ? '36px' : '16px'};
	width: 100%;
	margin: ${props => (props.isVisible ? `${GAP_SIZE / 2}px 0` : '2px 0')};
	border-radius: 8px;
	border: 2px dashed
		${props =>
			props.isOver
				? COLORS.main
				: props.isDraggingActive
					? 'rgba(0,0,0,0.1)'
					: 'transparent'};
	background-color: ${props =>
		props.isOver ? COLORS.mainSecondaryOpacity : 'transparent'};
	transition: all 0.2s ease;
	display: block;
	opacity: ${props => (props.isVisible || props.isDraggingActive ? 1 : 0)};
	overflow: hidden;
	position: relative;
	box-sizing: border-box;
	pointer-events: auto;
	flex-shrink: 0;
`
